export default __webpack_public_path__ + "media/images/home/living_support-9d6c147fe858787e035cb8b30f95580c.png";